<template>
  <my-popup
    title="模板选择"
    width="974"
    zIndex="3330"
    :flag="isShow"
    @close="popupClose"
  >
    <div class="head" v-show="!isOfficial">
      <!-- <div class="scorll" style="" v-if="iscareModul">模板案例</div> -->
      <div class="scorll">
        <i
          class="el-icon-caret-left left"
          @click="tabChange('prev')"
          :style="{ color: disabledPrev ? '#5882FB' : '#ddd' }"
        ></i>
        <div class="hidden">
          <ul
            class="tab_list"
            ref="tabList"
            :style="{ left: tabScrollLeft + 'px' }"
          >
            <li
              class="tab"
              :class="{ active: index === tabActive }"
              v-for="(item, index) in tabList"
              :key="index"
              @click="handleTabSwitch(index)"
            >
              {{ item.title }}
              <!-- <img src="../../assets/images/new.png" class="new" alt v-if="item.isNew" /> -->
            </li>
          </ul>
        </div>
        <i
          class="el-icon-caret-right right"
          @click="tabChange('next')"
          :style="{ color: disabledNext ? '#5882FB' : '#ddd' }"
        ></i>
      </div>
      <el-select
        v-model="tmpCustom"
        @change="switchDir"
        placeholder="请选择"
        style="width: 120px; marginleft: 12px"
      >
        <el-option
          v-for="(item, index) in customList"
          :key="index"
          :label="item.title"
          :value="item.tid"
        ></el-option>
      </el-select>
    </div>
    <div class="tableWrapper">
      <div style="padding: 15px 0">
        模板内容： <el-input v-model="content" style="width:250px;margin-right:40px"></el-input>
        <el-button type="primary" @click="searchData()">查询</el-button> <el-button @click="clearData()">重置</el-button>
      </div>
      <div class="tab-line" v-show="isOfficial">
        <el-tabs v-model="activeName" @tab-click="getTemplatesPage">
          <el-tab-pane label="系统模板" name="system"></el-tab-pane>
          <el-tab-pane label="自定义模板" name="custom"></el-tab-pane>
        </el-tabs>
        <div class="navigate" :style="{'color': globalBG}" @click="goCreateTemplate">去创建模板>></div>
      </div>
      <el-table
        :data="templateData"
        v-loading="tableLoading"
        :header-cell-style="{ paddingLeft: '20px','text-align': 'left' }"
        :cell-style="{ paddingLeft: '20px', 'text-align': 'center' }"
        style="width: 100%; border: 1px solid #e6e6e6"
        height="400"
        class="over-visible"
      >
        <el-table-column type="index" label="序号" width="80"></el-table-column>

        <el-table-column label="模板内容" width="500">
          <template slot="header" slot-scope="scope">
            <div
              style="
                display: inline-block;
                vertical-align: middle;
                margin-right: 10px;
              "
            >
              模板内容
            </div>
            <span
              class="table-message"
              v-show="!allShow"
              @click="allShow = true"
              >(展开全部)</span
            >
            <span
              class="table-message"
              v-show="allShow"
              @click="allShow = false"
              >(单行显示)</span
            >
          </template>
          <template slot-scope="scope">
            <div
              class="hoveTitle"
              v-if="!allShow"
              v-html="smsContent2html(scope.row.content)"
            ></div>
            <div
              v-if="allShow"
              v-html="smsContent2html(scope.row.content)"
            ></div>
          </template>
        </el-table-column>

        <el-table-column label="字数" width="100">
          <template slot-scope="scope">
            {{ scope.row.content | enVToChineseLength }}
          </template>
        </el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              class="useButtom"
              type="text"
              size="small"
              style="font-size: 14px;"
              @click="useTemplate(scope.$index, scope.row)"
              >使用</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 30, 50, 100]"
      :page-size="10"
      layout="total, sizes, prev, pager, next, jumper"
      class="pagination"
      :total="total"
    ></el-pagination>
  </my-popup>
</template>

<script>
import { mapState } from "vuex";
import {
  getTemplateDir,
  getTemplatesPage,
  getSpecialList,
} from "@/api/smsTemplates";
import myPopup from "../../components/myPopup";

export default {
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    isOfficial: {
      type: Boolean,
      default: false,
    },
    iscareModul: {
      type: Boolean,
      default: false,
    },
    tid: {
      default: "",
    },
  },
  computed: {
    ...mapState({
      globalLableList: "globalLableList",
      globalBG: "globalBG"
    }),
  },
  components: {
    myPopup,
  },
  data() {
    return {
      activeName: 'system',
      content: "",
      tabList: [{ name: "默认", id: 1, isNew: false }],
      tmpCustom: "",
      disabledNext: false,
      disabledPrev: false,
      tabSlideNum: 1,
      tabSlideMaxNum: 1,
      // tab栏滑动距离
      tabScrollLeft: 0,
      maxTabScrollLeft: 0,
      // tab栏选中项
      tabActive: 0,
      // 表格数据
      templateData: [],
      tableLoading: false,
      // 表格内容是否展开
      allShow: false,
      // 当前页
      currentPage: 1,
      total: 0,

      // 自定义模板栏目
      customList: [],

      paramPage: {
        size: 10,
        current: 1,
        tid: "",
      },
    };
  },
  mounted() {
    console.log(this.isOfficial);
    if (this.isOfficial) {
      this.paramPage.officialType = this.$route.meta.officialType;
      this.getTemplatesPage();
    } else {
      this.queryTabNum();
      this.getTemplateDir(); // 获取自定义栏目
      this.getSpecialList(); // 获取官方和节日栏目
    }
  },
  methods: {
    goCreateTemplate() {
      let routeUrl = this.$router.resolve({
        path: '/backstage/backstage/sms_module',
        query: {
          type: '1'
        }
      });
      window.open(routeUrl.href, "_blank");
    },
    smsContent2html(val) {
      var list = this.globalLableList;
      list.forEach((item, index) => {
        var label = item.key;
        var index = val.indexOf(label);
        if (index != "-1") {
          var html = [
            '<div class="ask-content-xx">',
            // `<span style="color: rgb(96, 105, 255)">${item.key}</span>`,
            `<span style="color: rgb(96, 105, 255)">#${item.value}#</span>`,
            '<div class="ask-icon-select">',
            item.value,
            "</div>",
            "</div>",
          ].join("");
          val = val.replace(label, html);
        }
      });
      return val;
    },

    handleTabSwitch(index) {
      this.tabActive = index;
      this.paramPage.tid = this.tabList[index].tid;
      this.getTemplatesPage();
    },

    // 切换自定义模板
    switchDir(val) {
      console.log(val);
      this.paramPage.tid = val;
      this.getTemplatesPage();
    },

    // 获取官方和节日栏目
    getSpecialList() {
      getSpecialList().then((res) => {
        if (res.code == "1") {
          var all = {
            tid: "",
            title: "全部",
          };
          var anli = {
            tid: this.tid,
            title: "模板案例",
          };
          this.tabList.unshift(all);

          if (this.iscareModul) {
            this.tabList.push(anli);
          } else {
            this.tabList = res.data;
          }
          this.paramPage.tid = res.data[0].tid;
          this.getTemplatesPage();
        }
      });
    },

    // 获取自定义栏目
    getTemplateDir() {
      var param = {
        type: 0,
      };
      getTemplateDir(param).then((res) => {
        if (res.code == "1") {
          console.log(res);
          this.customList = res.data;
          // this.tmpCustom = this.customList[0].tid;
        }
      });
    },
    //查询模板
    searchData() {
      // this.paramPage.content = this.content;
      this.paramPage.current = 1;
      this.getTemplatesPage();
    },
    clearData() {
      this.content = "";
      this.searchData();
    },
    // 获取模板列表
    getTemplatesPage() {
      this.tableLoading = true;
      this.paramPage.content = this.$ChineseVToEn(this.content);
      var param = JSON.parse(JSON.stringify(this.paramPage));
      if (this.activeName == 'custom') {
        // 商家申请模板
        param['isBusinessApply'] = true;
      } else if(this.isOfficial){
        param['isBusinessApply'] = false;
      }
      getTemplatesPage(param).then((res) => {
        this.tableLoading = false;
        if (res.code == "1") {
          this.templateData = res.data.records;
          this.total = +res.data.total;
        }
      });
    },

    // 弹窗隐藏
    popupClose() {
      this.$emit("close", false);
    },
    // tab栏目左右切换
    tabChange(type) {
      if (type === "prev") {
        // 左滑
        if (this.disabledPrev) {
          this.tabScrollLeft -= -686;
          if (Math.abs(this.tabScrollLeft) <= this.maxTabScrollLeft) {
            this.disabledPrev = false;
            this.disabledNext = true;
          }
        }
      } else {
        // 右滑
        if (this.disabledNext) {
          this.tabScrollLeft += -686;
          if (Math.abs(this.tabScrollLeft) >= this.maxTabScrollLeft) {
            this.disabledPrev = true;
            this.disabledNext = false;
          }
        }
      }
    },
    queryTabNum() {
      let num = Math.ceil(this.$refs.tabList.children.length / 9);
      if (num > 1) {
        this.disabledNext = true;
        this.maxTabScrollLeft = (num - 1) * 686;
      }
    },
    // 使用模板
    useTemplate(_index, _item) {
      this.$emit("close", true, _item);
    },
    /**
     * 分页事件
     */
    handleSizeChange(size) {
      this.paramPage.size = size;
      this.getTemplatesPage();
    },
    handleCurrentChange(current) {
      this.paramPage.current = current;
      this.getTemplatesPage();
    },
  },
};
</script>
<style lang="scss">
.ask-content-xx {
  position: relative;
  display: inline-block;
  vertical-align: text-top;
  cursor: pointer;
  line-height: 19px;
  .ask-icon {
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;
    position: relative;
  }
  .ask-icon-select {
    position: absolute;
    bottom: 50%;
    transform: translateY(50%);
    left: calc(100% + 20px);
    display: none;
    // height: 80px;
    line-height: 20px;
    background-color: #fff;
    box-shadow: 0 8px 20px rgba(139, 156, 188, 0.15);
    color: #999999;
    z-index: 9;
    width: 140px;
    text-align: center;
    margin-left: 0;
    padding: 10px 10px;
  }
  .ask-icon-select:before {
    position: absolute;
    content: "";
    width: 0;
    height: 0;
    left: 0;
    margin-left: -15px;
    top: 50%;
    transform: translateY(-48%);
    border-left: 8px solid transparent;
    border-top: 8px solid transparent;
    border-bottom: 8px solid transparent;
    border-right: 8px solid #fff;
  }
}
.ask-content-xx:hover {
  .ask-icon-select {
    // display: block;
  }
}
</style>
<style lang="scss" scoped>
/deep/ .el-table .el-table__header-wrapper th .cell {
  height: 60px;
  line-height: 50px;
  font-size: 14px;
  font-family: "Microsoft YaHei";
  font-weight: 500;
  text-align: center;
  -webkit-font-smoothing: antialiased;
  background-color: #fafafa;
  color: #333333;
}

/deep/.over-visible .el-table__row td {
  overflow: visible;
  .cell {
    overflow: visible;
  }
}
.tab-line {
  position: relative;
  .navigate{
    top: 0;
    right: 0;
    line-height: 40px;
    position: absolute;
    cursor: pointer;
  }
}
</style>

<style scoped lang="scss">
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.head {
  display: flex;
  align-items: center;
  height: 72px;
  border: none !important;
  .scorll {
    flex: 1;
    display: flex;
    align-items: center;
    .left {
      margin-right: 6px;
      cursor: pointer;
      flex-shrink: 0;
    }
    .right {
      margin-left: 6px;
      cursor: pointer;
      flex-shrink: 0;
    }
    .hidden {
      width: 686px;
      overflow: hidden;
      position: relative;
      height: 60px;
    }
    .tab_list {
      display: flex;
      align-items: center;
      position: absolute;
      height: 60px;
      transition: all 0.3s linear;
      .tab {
        position: relative;
        margin-right: 40px;
        cursor: pointer;
        white-space: nowrap;
        transition: color 0.1s;
        .new {
          position: absolute;
          top: -10px;
          right: -28px;
        }
        &:last-child {
          margin: 0;
        }
      }
      .active {
        color: #fe4d45;
      }
    }
  }
}
.tableWrapper {
  // max-height: 400px;
  // overflow: auto;
  // &::-webkit-scrollbar {
  //     width:8px;
  //     height:10px;
  // }
  // &::-webkit-scrollbar-track {
  //     background:rgba(246,246,246,1);
  //     border-radius: 2px;
  // }
  // &::-webkit-scrollbar-thumb {
  //     background: #ddd;
  //     border-radius:10px;
  // }
  // &::-webkit-scrollbar-thumb:hover {
  //     background: #ddd;
  // }
  .useButtom {
    color: #7f85e9;
    &:hover {
      color: #fe4d45;
    }
  }
  .table-message {
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;
    color: #fe4d45;
    font-weight: 400;
  }
  .hoveTitle {
    text-align: left;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>
<style lang="scss">
.el-popper {
  z-index: 3555 !important;
}
</style>
